import SajuResultPage from '@/pages/saju-result/index.vue';

export const manseRoutes = [
  // 실제 라우트
  {
    path: '/saju-result/:id/:pgmode',
    name: 'saju-result',
    component: SajuResultPage,
    meta: {
      layout: 'manse',
    },
  },
];
